/**
 * The shell's words for the offline outbox (docs/design/offline-outbox.md §8): the header pill, the
 * outbox panel and what a form says when it keeps a request on this device. Kept beside the catalogue
 * and spread into it, like the kept reads' (i18n-offline.ts). No key, address or idempotency key is
 * ever said (T-4).
 */
export const OUTBOX_EN = {
    'shell.outbox.pill.waiting': '{n} waiting to be sent',
    'shell.outbox.pill.attention': '{n} need your attention',
    'shell.outbox.pill.offline': 'Offline',
    'shell.outbox.title': 'Waiting to be sent',
    'shell.outbox.lede': 'Saved on this device while its service could not be reached. Each is sent in the order it was made, once the connection is back.',
    'shell.outbox.offline': 'You are offline. What waits here is sent once you are back online.',
    'shell.outbox.empty': 'Nothing is waiting to be sent.',
    'shell.outbox.state.waiting': 'Waiting',
    'shell.outbox.state.sending': 'Sending',
    'shell.outbox.state.attention': 'Needs attention',
    'shell.outbox.savedAt': 'Saved at {when}',
    'shell.outbox.refused': 'Not accepted: {reason}',
    'shell.outbox.sendNow': 'Send now',
    'shell.outbox.open': 'Open',
    'shell.outbox.discard': 'Discard',
    'shell.outbox.discard.title': 'Discard «{label}»?',
    'shell.outbox.discard.body': 'It will not be sent, and what was entered in it is lost from this device.',
    'shell.outbox.close': 'Close',
    'shell.outbox.saved': 'Saved on this device — it will be sent when you are back online.',
    'shell.outbox.sent': 'Sent: {label}',
    'shell.outbox.sentMany': '{n} waiting requests were sent.',
    'shell.outbox.needsAttention': '«{label}» was not accepted. Open what waits to be sent to see why.',
};
export const OUTBOX_AR = {
    'shell.outbox.pill.waiting': '{n} بانتظار الإرسال',
    'shell.outbox.pill.attention': '{n} يحتاج انتباهك',
    'shell.outbox.pill.offline': 'غير متصل',
    'shell.outbox.title': 'بانتظار الإرسال',
    'shell.outbox.lede': 'حُفظت على هذا الجهاز حين تعذّر الوصول إلى خدمتها، وتُرسل بترتيب إنشائها حين يعود الاتصال.',
    'shell.outbox.offline': 'أنت غير متصل، وما ينتظر هنا يُرسل حين يعود الاتصال.',
    'shell.outbox.empty': 'لا شيء بانتظار الإرسال.',
    'shell.outbox.state.waiting': 'بانتظار الإرسال',
    'shell.outbox.state.sending': 'يُرسل الآن',
    'shell.outbox.state.attention': 'يحتاج انتباهك',
    'shell.outbox.savedAt': 'حُفظ في {when}',
    'shell.outbox.refused': 'لم يُقبل: {reason}',
    'shell.outbox.sendNow': 'أرسل الآن',
    'shell.outbox.open': 'افتح',
    'shell.outbox.discard': 'تجاهل',
    'shell.outbox.discard.title': 'تجاهل «{label}»؟',
    'shell.outbox.discard.body': 'لن يُرسل، ويُحذف ما أُدخل فيه من هذا الجهاز.',
    'shell.outbox.close': 'إغلاق',
    'shell.outbox.saved': 'حُفظ على هذا الجهاز، ويُرسل حين يعود الاتصال.',
    'shell.outbox.sent': 'أُرسل: {label}',
    'shell.outbox.sentMany': 'أُرسلت {n} من الطلبات المنتظرة.',
    'shell.outbox.needsAttention': 'لم يُقبل «{label}». افتح ما ينتظر الإرسال لترى السبب.',
};
//# sourceMappingURL=i18n-outbox.js.map